; (function () {
    var
        $wrapper = null,

        //
        // init 
        //
        init = function () {
            $wrapper = $('.layout-admin-users');
            $.fn.dataTable.ext.errMode = 'none';

            if ($wrapper.length > 0) {
                setupDataTable();
                setupWindowResize();
            }
        },

        ctrlResetButton = function () {
            let e = document.createElement('div');
            e.classList.add('dt-search');
            e.innerHTML = `<button id="btnResetUsersTable" class="btn btn-primary btn-sm">Reset</button>`;
            return e;
        },

        setupResetBtn = function () {
            $('#btnResetUsersTable').click(function () {
                $('#adminUsersDataTable').DataTable().search('').order([[0, 'asc']]).draw();
            });
        },

        setupDataTable = function () {
            if (DataTable.isDataTable('#adminUsersDataTable')) {
                new DataTable.Api('#adminUsersDataTable').ajax.reload();
                return;
            }

            $('#adminUsersDataTable').DataTable({
                layout: {
                    topStart: null,
                    topEnd: null,
                    bottomStart: null,
                    bottomEnd: null,
                    top: ['search', 'pageLength'],
                    bottom: ['info', 'paging'],
                },
                language: { search: "" },
                pageLength: 25,
                processing: true,
                serverSide: true,
                orderMulti: false,
                ajax: {
                    url: '/admin/user/search',
                    method: 'post',
                    dataType: 'json',
                    dataSrc: 'data'
                },
                initComplete: function () {
                    setupUserActions();
                    setupResetBtn();
                },
                columnDefs: [
                    { orderSequence: ["asc", "desc"], targets: [0, 1, 2] },
                    { orderSequence: ["desc", "asc"], targets: [4] }
                ],
                order: [[0, "asc"]],
                columns: [
                    {
                        title: 'Last Name',
                        data: 'lastName',
                        name: 'LastName',
                        width: '20%'
                    },
                    {
                        title: 'First Name',
                        data: 'firstName',
                        name: 'FirstName',
                        width: '20%'
                    },
                    {
                        title: 'Email',
                        data: 'email',
                        name: 'Email',
                        width: '25%'
                    },
                    {
                        title: 'Status',
                        data: 'active',
                        name: 'Active',
                        className: 'dt-center',
                        width: '10%',
                        render: function (data, type, row) {
                            return data ?
                                `<a href="#" class="lnk-toggle-status text-success" data-user-id="${row.id}" data-current-status="true"title="Click to deactivate">Deactivate</a>` :
                                `<a href="#" class="lnk-toggle-status text-danger" data-user-id="${row.id}" data-current-status="false"title="Click to activate">Activate</a>`;
                        }
                    },
                    {
                        title: 'Last Login',
                        data: 'lastLogin',
                        name: 'LastLogin',
                        className: 'dt-center',
                        width: '15%',
                        render: function (data, type, row) {
                            if (data && data !== 'Never') {
                                var date = new Date(data);
                                return date.toLocaleDateString();
                            }
                            return 'Never';
                        }
                    },
                    {
                        title: 'Client List',
                        data: null,
                        orderable: false,
                        className: 'dt-center',
                        width: '10%',
                        render: function (data, type, row) {
                            return `<a href="#" class="lnk-view-clients" data-user-id="${row.id}" data-user-name="${row.firstName} ${row.lastName}"title="View assigned clients">View</a>`;
                        }
                    }
                ]
            });

            // Style the search box
            let $searchBox = $wrapper.find('#dt-search-0');
            $searchBox.attr('placeholder', 'Search ...').addClass('form-control form-control-sm ms-0 me-1');
            $searchBox.wrap("<div style='display: inline-flex; align-items: center;'></div>");
            $searchBox.after(ctrlResetButton());
        },


        setupUserActions = function () {
            // Toggle user status
            $(document).on('click', '.lnk-toggle-status', function (e) {
                e.preventDefault();
                var userId = $(this).data('user-id');
                var currentStatus = $(this).data('current-status') === 'true';
                var actionText = currentStatus ? 'deactivate' : 'activate';

                delta.ajax.post('/admin/user/status', { userID: userId }, function (res) {
                    if (res.ok) $('#adminUsersDataTable').DataTable().ajax.reload(); // reload table
                    else alert('Error updating user status: ' + result.error);
                });
            });

            // View user's clients
            $(document).on('click', '.lnk-view-clients', function (e) {
                e.preventDefault();
                var userId = $(this).data('user-id');
                var userName = $(this).data('user-name');

                delta.ajax.get(`/admin/user/clients?userID=${userId}`, function (html) {
                    delta.popup.open({
                        type: 'alert',
                        title: `Client List - ${userName}`,
                        content: html,
                        css: 'user-clients-popup modal-lg'
                    });
                });
            });
        },

        setupWindowResize = function () {
            var resizeTimer;
            $(window).on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    // Adjust DataTable columns on window resize
                    if ($.fn.DataTable.isDataTable('#adminUsersDataTable')) {
                        var table = $('#adminUsersDataTable').DataTable();
                        table.columns.adjust();
                        // Only call responsive.recalc if responsive extension is available
                        if (table.responsive && typeof table.responsive.recalc === 'function') {
                            table.responsive.recalc();
                        }
                    }
                }, 250);
            });
        },

        dummy = function () { };

    $(document).ready(init);
})();